import Vue from "vue";
import VueRouter from "vue-router";
import routes from './routes'

Vue.use(VueRouter);

const router = new VueRouter({
  mode: "hash",
  routes,
})

// 路由白名单
const whitelist = ['/login', '/register', '/switchLang', '/privacy', '/terms', '/introduce',]

router.beforeEach((to, from, next) => {
  // 检查 token 是否过期
  const token = localStorage.getItem('token')
  if (whitelist.includes(to.path) || token) next()
  else next({ path: '/login' })
})

export default router
